module.exports = __webpack_public_path__ + "static/media/Lewis Cass - 1848.c46d8780.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Lewis Cass - 1848.jpg
// module id = 528
// module chunks = 0